/** Creator Map / Influencer Map route path. */
export const CREATOR_MAP_PATH = '/creator-map';

/**
 * Hide map entry points at MUI `down('md')` (below 900px).
 * Matches the marketplace list↔map toggle (desktop-only below md).
 */
export const CREATOR_MAP_MOBILE_MQL = '(max-width: 899.95px)';
